import { render } from "./voucherAr.vue?vue&type=template&id=65a2e226&scoped=true"
import script from "./voucherAr.vue?vue&type=script&lang=js"
export * from "./voucherAr.vue?vue&type=script&lang=js"

import "./voucherAr.vue?vue&type=style&index=0&id=65a2e226&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65a2e226"]])

export default __exports__